@if (!isStyleGuideRoute && !capabilities.mode() && windowLocationIsNotStatic404) {
  <main class="min-vh-100 bg-light d-flex align-items-center justify-content-center p-4" aria-live="polite">
    <section class="card shadow-sm border-0 text-center p-4 p-md-5" style="max-width:480px" role="status">
      <img class="mx-auto mb-4" src="assets/logo.png" alt="Kartorium" width="64">
      @if (capabilities.error()) {
        <h1 class="h3 fw-semibold">Account access settings unavailable</h1>
        <p>{{ capabilities.error() }}</p>
        <button class="btn btn-primary btn-lg" [disabled]="capabilities.loading()" (click)="retryCapabilities()">Try Again</button>
      } @else {
        <h1 class="h3 fw-semibold">Loading account access settings</h1>
        <span class="spinner-border mx-auto" aria-label="Loading"></span>
      }
    </section>
  </main>
}
@if (isAuthCallbackRecoveryVisible) {
  <div class="auth-callback-recovery" role="alert" aria-live="assertive">
    <div class="auth-callback-recovery__panel">
      <img class="auth-callback-recovery__logo" src="assets/logo.png" alt="Kartorium">
      <h1>Sign-in is taking longer than expected</h1>
      <p>The sign-in callback did not finish. Continue sign-in to try again.</p>
      <button type="button" class="btn btn-primary" (click)="retryLoginAfterAuthCallback()">
        Continue sign-in
      </button>
    </div>
  </div>
}

@if (currentModule == 'builder' || currentModule == 'viewer') {
  <shared-loading-screen [showTips]='currentModule == "builder"'
  ></shared-loading-screen>
}

<!-- App Sidebar Navigation (for main pages) -->
@if (shouldShowSidebar) {
  <shared-app-sidebar></shared-app-sidebar>
}

<!-- Mobile Navigation (for main pages on mobile) -->
@if (shouldShowSidebar && isMobile) {
  <shared-navbar-mobile></shared-navbar-mobile>
}

<!-- User Profile Modal -->
<div class="modal fade" id="staticBackdrop" tabindex="-1" role="dialog" aria-labelledby="staticBackdropLabel"
  aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered modal-lg" role="document">
    @if (bothUsers$ | async; as user) {
      <div class="modal-content">
        <!-- Modal Header -->
        <div class="modal-header bg-light border-bottom">
          <h2 class="modal-title text-dark" id="staticBackdropLabel">User Profile</h2>
          <button class="btn btn-close text-dark" data-bs-dismiss="modal" aria-label="Close"></button>
        </div>
        <!-- Modal Body -->
        <div class="modal-body">
          <div class="row align-items-center mb-4">
            <!-- Profile Picture -->
            <div class="col-md-3 text-center">
              <img [src]="user.picture" alt="User's profile picture"
                class="rounded-circle img-fluid profile-picture shadow" />
              </div>
              <!-- User Information -->
              <div class="col-md-9">
                <div class="text-center text-md-left">
                  <h4 class="mb-1">{{ user.name }}</h4>
                  <p class="text-muted mb-0"><i class="fas fa-envelope me-2"></i>{{ user.email }}</p>
                </div>
              </div>
            </div>
            <!-- Edit and Reset Buttons -->
            <div class="d-flex justify-content-between mt-4">
              <div>
                @if (!editing) {
                  <button class="btn btn-outline-primary btn-sm" (click)="editing = !editing">
                    <i class="fas fa-edit"></i> Edit Profile
                  </button>
                }
                @if (editing) {
                  <button class="btn btn-outline-secondary btn-sm"
                  (click)="editing = !editing">Cancel</button>
                }
              </div>
              @if (user.canResetPassword) {
                <button (click)="resetPassword()" class="btn btn-primary btn-sm">Reset Password</button>
              }
            </div>
            <!-- Edit Mode -->
            @if (editing) {
              <div class="mt-4">
                <div class="mb-3">
                  <label for="editName" class="form-label">Name</label>
                  <input id="editName" type="text" class="form-control" [(ngModel)]="user.name"
                    (change)="updateUser(user)" />
                  </div>
                  <div class="mb-3">
                    <label for="editPicture" class="form-label">Profile Picture URL</label>
                    <input id="editPicture" type="text" class="form-control" [(ngModel)]="user.picture"
                      (change)="updateUser(user)" />
                    </div>
                  </div>
                }
                <!-- Organization Picker -->
                <div class="mt-4 p-3 border rounded shadow-sm bg-light">
                  <h5 class="mb-1">Organizations</h5>
                  <shared-organization-picker></shared-organization-picker>
                </div>
              </div>
              <!-- Feedback Section -->
              <div class="d-flex align-items-center justify-content-between px-3 py-3 border-top bg-light">
                <small class="text-muted">Have feedback?</small>
                <a class="text-primary" style="cursor: pointer; text-decoration: underline" data-bs-dismiss="modal"
                (click)="navigateToFeedback()">Submit feedback here</a>
              </div>
              <!-- Modal Footer -->
              <div class="modal-footer d-flex justify-content-between">
                <button (click)="logout()" class="btn btn-outline-danger btn-sm">Sign Out</button>
                <button class="btn btn-secondary btn-sm" data-bs-dismiss="modal">Close</button>
              </div>
            </div>
          }
        </div>
      </div>

<div (pointerdown)="closeContextMenu()" class="app-container" [ngClass]="{
       'with-sidebar': shouldShowSidebar && !isMobile,
       'style-guide-route': isStyleGuideRoute
     }">
        @if (isStyleGuideRoute || capabilities.mode() || !windowLocationIsNotStatic404) {
          <router-outlet></router-outlet>
        }
      </div>

      <!-- Toast Container for notifications -->
      <div class="app-toast-container m-3">
        <shared-toast-container></shared-toast-container>
      </div>

      <ng-template contextMenu></ng-template>
